export default __webpack_public_path__ + "static/media/undraw_doctor_kw5l.6247393d.svg";